module.exports = {
  roomOnlyPriceText: 'Room only price',
  includingOneWeekParkingText: 'inc. 1 week parking',
  carParkText: 'Car Park',
  hotelText: 'Hotel',
  starsText: 'Stars',
  distanceText: 'Distance',
  transfersText: 'Transfers',
  loungeText: 'Lounge',
  timesText: 'Times',
  ratingText: 'Rating',
  priceText: 'Price',
  pricePerDayText: 'Price p/d',
  pricePerWeekText: 'Price p/w',
  notRequiredText: 'Not required',
  minutesShortText: 'mins',
  includedText: 'Included',
  milesText: 'miles',
  onAirportText: 'On airport',
  mapAndDirectionsText: 'Map and Directions',
  photosText: 'Photos',
  videoText: 'Video',
  reviewsText: 'Reviews',
  customerReviewsText: 'Customer Reviews',
  thisIsAGuidePriceOnlyText: 'This is a guide price only',
  loungeOpenTimesText: 'This lounge is open from OPENINGTIME until CLOSINGTIME',
  loungeOpenTimesShortText: 'Open from <strong>OPENINGTIME</strong> to <strong>CLOSINGTIME</strong>',
  bookAgainText: 'AVERAGEASPERCENTAGE% of COUNT guests said they would use this car park again.',
  carParkingCaveat: '*This is an example price for reservations between STARTDATE and ENDDATE, valid as of DATEUSED.  The price per week is the total cost of this car parking for 8 days. The price per day refers to the same product and period, divided by 8.',
  otherCaveat: '*This is an example price for a reservation on STARTDATE, valid as of DATEUSED.',
  lowestPriceOnlyLabel: 'From '
}



// WEBPACK FOOTER //
// ./shared/config/components/productList/uk/index.js